<script lang="ts">
	import type { AggregatedPunchStats } from '../types';
	import KnockdownColumn from './KnockdownColumn.svelte';

	export let blue: AggregatedPunchStats;
	export let red: AggregatedPunchStats;
</script>

<div class="d-flex mt-4 justify-content-between">
	<div class="empty-sidebar d-none d-sm-block" />

	<KnockdownColumn stats={blue} corner="blue" />
	<KnockdownColumn stats={red} corner="red" />
</div>

<style>
	.empty-sidebar {
		width: 20%;
	}
</style>
